import BasePagination from './Index.vue'

BasePagination.install = function(Vue) {
  Vue.component(BasePagination.name, BasePagination)
}

export default BasePagination
